module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/open/bb3133d0add1691f9a97d0b8068c059f.png";